import { Typography } from '@sanlam-glacier/app-common/components';
import clsx from 'clsx';
import styles from '../../TopBar.module.scss';

interface SearchResultHeaderProps {
  resultCount: number;
  expectSingleResult?: boolean;
}

export const SearchResultHeader = ({
  resultCount,
  expectSingleResult
}: SearchResultHeaderProps) => {
  return expectSingleResult ? (
    <div className={clsx(styles.switchProfileInfo, styles.contextMenuExtraSidePadding)}>
      <Typography variant={Typography.VARIANT.O1} color={Typography.COLOR.INHERIT}>
        SEARCH RESULT:
      </Typography>
    </div>
  ) : (
    <div className={clsx(styles.switchProfileInfo, styles.contextMenuExtraSidePadding)}>
      <Typography align={Typography.ALIGN.LEFT}>
        <strong>{`${resultCount} ${
          resultCount > 1 || resultCount == 0 ? 'results' : 'result'
        } found`}</strong>
      </Typography>
    </div>
  );
};
